import gsap from 'gsap';
import barba from '@barba/core';
import emitter from 'tiny-emitter/instance';
class MagneticButton{

    constructor() {
        this.wrapper = document.querySelector('.back-wrapper')
        if(this.wrapper == null) {
            return false;
        }
        this.back = document.querySelector('.back')
        this.tracker =  document.querySelector('.cursor-tracker')
        this.pointers =  document.querySelectorAll('.cursor-pointer')
        this.backText = document.querySelector('.back__btn')
        this.wrapperBound = this.wrapper.getBoundingClientRect()

        this.mousepos = {x: 0, y: 0};
        this.triggerDistance = 50
        this.init()
        emitter.on('barba::after', this.checkButtonVisibility, this);
    }

    init(){
        this.setupWrapper()
        this.bindEvents()
        this.checkButtonVisibility()
    }

    setupWrapper(){
        this.wrapper.style.padding = this.triggerDistance+'px'
        this.wrapper.style.transform = `translate(-${this.triggerDistance}px,-${this.triggerDistance}px)`
    }

    bindEvents(){
        this.wrapper.addEventListener('mouseenter',this.enter.bind(this))
        this.wrapper.addEventListener('mouseleave',this.leave.bind(this))

        this.wrapper.addEventListener('mousemove',(e)=>{
            /** apply movement method **/
            this.movement(e,this.back,20)
        })
    }

    checkButtonVisibility() {
        if(barba.history.previous == null) {
            this.wrapper.style.display = 'none'
            this.wrapper.dataset.visibility = 'none'
        } else {
            this.wrapper.style.display = null
            this.wrapper.dataset.visibility = 'visible'
            this.back.removeEventListener('click', this.goToUrlButton)
            this.back.addEventListener('click', this.goToUrlButton)
        }
    }

    goToUrlButton() {
        barba.go(barba.history.previous.url)
    }

    movement(e,target,movement){

        this.mousepos.x = e.pageX - this.wrapperBound.left;
        this.mousepos.y = e.pageY - this.wrapperBound.top;
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop

        //console.log(this.mousepos.x,this.mousepos.y)

        gsap.to(target, 0.3, {
            x: (this.mousepos.x - this.wrapperBound.width/2) / this.wrapperBound.width * movement,
            y: (this.mousepos.y - this.wrapperBound.height/2 - this.scrollTop) / this.wrapperBound.width * movement,
            ease: 'power3.Out',
        });
    }


    /** transitions **/
    enter(){
        gsap.to(this.back,{duration:0.3,scale:1.2,background: 'currentColor'})
        gsap.to(this.backText,{duration:0.3,color: 'white'})
        gsap.to(this.tracker,{duration:0.3,autoAlpha:0})
        this.pointers.forEach(el=>{
            gsap.to(el,{duration:0.3,autoAlpha:0})
        })
    }

    leave(){
        gsap.to(this.back,{duration:0.3,scale:1,translateX:'0',translateY:'0',background:'transparent'})
        gsap.to(this.backText,{duration:0.3,color: 'currentColor'})
        gsap.to(this.tracker,{duration:0.3,autoAlpha:1})
        this.pointers.forEach(el=>{
            gsap.to(el,{duration:0.3,autoAlpha:1})
        })
    }

}

//module.exports = MagneticButton;
export default MagneticButton



// WEBPACK FOOTER //
// ./scripts/utils/effects/magneticButton.js